import React from "react";
import Slider from "react-slick";
import { FaStar, FaArrowLeft, FaArrowRight, FaStarHalf, FaStarHalfAlt } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./TestimonialContainer.module.css";
import { useQuery } from "@tanstack/react-query";
import { getTestimonialsList } from "../../api/containersApi";

// const testimonials = [

//   {
//     companyLogo: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Google-flutter-logo.svg/2048px-Google-flutter-logo.svg.png",
//     name: "Unifocus",
//     country: "USA",
//     rating: 4,
//     text: `NuFolks team stands out as a Recruitment Consultancy. After our initial intake call, they quickly understood our business and the requirements of the role. The team is highly professional and goes an extra mile for both the candidate and the client. It is always a pleasure working with them.`,
//   },
//   {
//     companyLogo: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Google-flutter-logo.svg/2048px-Google-flutter-logo.svg.png",
//     name: "TSeries",
//     country: "India",
//     rating: 5,
//     text: `NuFolks team stands out as a Recruitment Consultancy. After our initial intake call, they quickly understood our business and the requirements of the role. The team is highly professional and goes an extra mile for both the candidate and the client. It is always a pleasure working with them.`,
//   },
//   {
//     companyLogo: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Google-flutter-logo.svg/2048px-Google-flutter-logo.svg.png",
//     name: "Unifocus",
//     country: "USA",
//     rating: 4,
//     text: `NuFolks team stands out as a Recruitment Consultancy. After our initial intake call, they quickly understood our business and the requirements of the role. The team is highly professional and goes an extra mile for both the candidate and the client. It is always a pleasure working with them.`,
//   },
//   {
//     companyLogo: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Google-flutter-logo.svg/2048px-Google-flutter-logo.svg.png",
//     name: "Unifocus",
//     country: "Canda",
//     rating: 5,
//     text: `NuFolks team stands out as a Recruitment Consultancy. After our initial intake call, they quickly understood our business and the requirements of the role. The team is highly professional and goes an extra mile for both the candidate and the client. It is always a pleasure working with them.`,
//   },
// ];

const NextArrow = ({ onClick }) => (
  <div className={styles.nextArrow} onClick={onClick}>
    {/* <FaArrowRight /> */}
    <svg
        width="60" height="60" viewBox="0 0 66 67" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="0.5" width="66" height="66" rx="33" fill="#FF9900"/>
        <g clip-path="url(#clip0_36_252)">
        <path d="M47.6563 32.6705C47.6559 32.6701 47.6556 32.6697 47.6552 32.6694L41.532 26.5756C41.0732 26.1191 40.3312 26.1208 39.8746 26.5796C39.4181 27.0383 39.4198 27.7803 39.8786 28.2369L43.9897 32.3281H19.1719C18.5246 32.3281 18 32.8528 18 33.5C18 34.1472 18.5246 34.6719 19.1719 34.6719H43.9897L39.8786 38.7631C39.4199 39.2197 39.4181 39.9617 39.8747 40.4204C40.3313 40.8792 41.0733 40.8808 41.532 40.4244L47.6553 34.3306C47.6556 34.3303 47.6559 34.3299 47.6563 34.3295C48.1153 33.8714 48.1138 33.127 47.6563 32.6705Z" fill="white"/>
        </g>
        <defs>
        <clipPath id="clip0_36_252">
        <rect width="30" height="30" fill="white" transform="translate(18 18.5)"/>
        </clipPath>
        </defs>
    </svg> 
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className={styles.prevArrow} onClick={onClick}>
    <svg width="66" height="67" viewBox="0 0 66 67" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.806641" width="66" height="66" rx="33" fill="#FF9900"/>
      <g clip-path="url(#clip0_342_277)">
      <path d="M18.3437 32.9771C18.3441 32.9768 18.3444 32.9764 18.3448 32.976L24.468 26.8823C24.9268 26.4258 25.6688 26.4275 26.1254 26.8862C26.5819 27.345 26.5802 28.0869 26.1214 28.5435L22.0103 32.6348H46.8281C47.4754 32.6348 48 33.1594 48 33.8066C48 34.4539 47.4754 34.9785 46.8281 34.9785H22.0103L26.1214 39.0698C26.5801 39.5263 26.5819 40.2683 26.1253 40.727C25.6687 41.1859 24.9267 41.1875 24.468 40.731L18.3447 34.6373C18.3444 34.6369 18.3441 34.6365 18.3437 34.6361C17.8847 34.1781 17.8862 33.4337 18.3437 32.9771Z" fill="white"/>
      </g>
      <defs>
      <clipPath id="clip0_342_277">
      <rect width="30" height="30" fill="white" transform="matrix(-1 0 0 1 48 18.8066)"/>
      </clipPath>
      </defs>
    </svg>
    {/* <FaArrowLeft /> */}
  </div>
);

const TestimonialContainer = ({heading, isSubHeading, subheading, isEmployeeTestimonial}) => {

  const { data : testimonialsList } = useQuery({
    queryKey: ["testimonialsList"],
    queryFn: () => getTestimonialsList({ auth_key: localStorage.getItem("sessionToken") }),
  });
  
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    pauseOnHover: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    cssEase: "linear",
    // appendDots: dots => (
    //   <div className={styles.dotsWrapper}>
    //     <ul>{dots}</ul>
    //   </div>
    // ),
    // customPaging: () => <div className={styles.customDot}></div>,
  };

  return (
    <div className={`${styles.outer} ${!isEmployeeTestimonial && styles.outerWithBorder}`}>

    <h1>{heading}</h1>  
    {isSubHeading && <p className={styles.subheadingStyle}>{subheading}</p>}
    <div className={styles.sliderContainer}>
      <Slider {...settings}>
        {testimonialsList?.map((item, index) => (
          <div style={{overflow: "hidden"}} key={index}>
            
            <div className={styles.card}>
              
              <div className={styles.header}>
                <div className={styles.section1}>
                  <div>
                    <img src={item?.logo} alt="logo" className={styles.logo} />
                  </div>
                  <div>
                    <p className={styles.company}>{item?.clientName}</p>
                    <p className={styles.country}>{item?.location?.city}, {item?.location?.state}</p>
                  </div>
                </div>
                {
                  !isEmployeeTestimonial &&
                  <div className={styles.stars}>
                    {
                      Number.isInteger(item?.star_rating) 
                        ? 
                      [...Array(5)]?.map((_, i) => {
                        return <FaStar key={i} color={i < item?.star_rating ? "#facc15" : "#e5e7eb"} />
                      }) 
                        :
                      <>
                        {
                          [...Array(Math.floor(item?.star_rating))]?.map((_, i) => {
                            return <FaStar key={i} color="#facc15" />
                          })
                        }
                        {
                          <FaStarHalfAlt color="#facc15" />
                        }
                        { Math.floor(item?.star_rating) < 4 && 
                          [...Array(4 - Math.floor(item?.star_rating))]?.map((_, i) => {
                            return <FaStar key={i} color="#e5e7eb" />
                          })                        
                        }
                      </>                       
                    }
                  </div>
    }
              </div>

              <p className={styles.text} title={item?.description}>
                {(item?.description)?.length > 300 ? (item?.description)?.substring(0, 350) + "..." : item?.description}
                {/* {item?.description} */}
              </p>
            
            </div>
          
          </div>
        ))}
      </Slider>
    </div>
    </div>
  );
};

export default TestimonialContainer;
